import { getAuthorization } from "./getAuthorization";
import { getAuthorizationId } from "./getAuthorizationId";

export const authorizationService = { getAuthorization, getAuthorizationId };
